<template lang="html">
    <vs-alert :active.sync="isActive"
                :color="type"
                :icon="icon"
                :closable="closable"
                close-icon="close">

        <div v-html="content"></div>
    </vs-alert>
</template>

<script>
    export default {
        data() {
            return {
                isActive: true,
                defaultIcon: "",
                defaultType: "primary", // primary, success, danger, warning, dark, RGB, HEX
                defaultContent: "",
                content: "",
                type: "",
                icon: "", // https://material.io/tools/icons
                closable: false
            }
        },
        methods: {
            show: function (type, content, icon, closable) {
                if (type) {
                    this.type = type;
                } else {
                    this.type = this.defaultType;
                }

                if (content) {
                    this.content = content;
                } else {
                    this.content = this.defaultContent;
                }

                if (icon) {
                    this.icon = icon;
                } else {
                    this.icon = this.defaultIcon;
                }

                if (closable !== null) {
                    this.closable = closable;
                } else {
                    this.closable = false;
                }

                this.isActive = true;
            }
        }
    }
</script>
